import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';

const updateTripAvailabilityMutation = graphql(/* GraphQL */ `
  mutation updateTripAvailability($input: UpdateTripAvailabilityInput!) {
    updateTripAvailability(input: $input)
  }
`);

export type RoomAvailabilityUpdate = {
  roomId: number;
  availableRooms: number;
};

export type UpdateTripAvailabilityInput = {
  tripId: number;
  roomAvailabilities: RoomAvailabilityUpdate[];
};

const useUpdateTripAvailability = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useMutation({
    mutationFn: async (input: UpdateTripAvailabilityInput) => {
      if (!isAuthenticated) {
        throw new Error(
          'User must be authenticated to update trip availability',
        );
      }
      return graphqlRequest(
        updateTripAvailabilityMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    // Removed automatic query invalidation to prevent refresh/login issues
    // Data is updated optimistically in the component
  });
};

export default useUpdateTripAvailability;
